<template>
  <div id="scrollwj" ref="scrollwj" :style="{top: y + 'px', left: x + 'px'}" @mouseover="cleartime"  @mouseout="interval">
    <img v-for="item in floatBanner" :key="item.id" :src="item.image" alt="" srcset="" >
    <!-- <img src="./../../assets/image/index-sy2.png" alt="" srcset="" > -->
  </div>
</template>
<script>
export default {
  name: 'animation',
  props: ['floatBanner'],
  data () {
    return {
      timerName: null,
      xSpeed: 2,
      ySpeed: 1,
      w:document.documentElement.clientWidth - 370,
      h:document.documentElement.clientHeight - 600,
      x: 100,
      y: 100
    }
  },
  mounted () {
    this.fileImg()
  },
  methods: {
    fileImg() {
      if(this.x > this.w || this.x < 0) {
          this.xSpeed = -this.xSpeed; 
      }
      if( this.y > this.h || this.y < 0 ) {
          this.ySpeed = -this.ySpeed;
      }
      const newX = this.x + this.xSpeed; 
      const newY = this.y + this.ySpeed; 
      this.x = newX; 
      this.y = newY;
      this.$set(this, 'x', newX)
      this.$set(this, 'y', newY)
      this.interval(); 
    },
    interval() {
      this.timerName= setTimeout(this.fileImg, 40);
    },
    cleartime () {
      clearTimeout(this.timerName)
    }
  }
}
</script>
<style lang="scss" scoped>
  #scrollwj{
    position: absolute;
    z-index: 10000;
    top: 20px;
    left: 100px;
    background: transparent;
    img{
      width: 180px;
      height: 254px;
      margin-right: 10px;
      &:last-child {
        margin-right: 0;
      }
    }
  }

  #scrollwj img:hover{
    transform: scale(3.0);
  }
</style>



// WEBPACK FOOTER //
// src/components/index/animation.vue